import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import packageJson from '../../../package.json'

i18next
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        interpolation: {
            escapeValue: false,
        },
        fallbackLng: ['en', 'pl'],
        backend: {
            loadPath: `/locales/{{lng}}/translation.json?v=${packageJson.appVersion}`,
        },
        detection: {
            // Options for the language detector
            order: ['navigator', 'htmlTag', 'path', 'subdomain'],
            caches: ['localStorage', 'cookie'],
        },
        supportedLngs: ['en', 'pl'],
    })

i18next.on('languageChanged', (lng: string) => {
    document.documentElement.lang = lng
})

export { i18next }
